<template>
  <div>
    <ContentHeader/>
    <div class="content-container">
      <div class="text-center">
        <h3 class="font-weight-700">404</h3>
        <br>
        <h5>PAGE NOT FOUND</h5>
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from '../../components/content-header'
export default {
  name: 'page-404',
  components: {
    ContentHeader
  }
}
</script>

<style lang="scss" scoped>
</style>
